
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discovery",
      function () {
        return require("private-next-pages/discovery/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discovery"])
      });
    }
  